import Image from 'next/image';

function BannerImage() {
  return <Image src="/whatWIllYouGetHighRes.png" width={526} height={488} alt="You will Get Img" />;
}

export default BannerImage;
